import { isNull } from '../misc/Utils'
export default class ProductGallery {
    constructor() {
        this.cacheDom()
        this.bindEvents()
    }

    cacheDom() {
        this.bodyEl = document.body
        this.activeImage = 0
        this.thumbnails = document.querySelectorAll('.product-gallery-thumbnails img')
        this.imageArray = Array.from(this.thumbnails)
        this.lastImage = this.imageArray.length - 1

        this.container = document.querySelector('.product-gallery')
        this.previewImage = document.querySelector('.product-gallery-preview img')
        this.arrows = document.querySelectorAll('.product-gallery-arrows')
        this.close = document.querySelector('.product-gallery-close')
    }

    bindEvents() {
        document.addEventListener('click', (e) => {
            if (e.target.classList.contains('gallery')) {
                this.handleImageClick(e)
            }
        })

        Array.prototype.forEach.call(this.arrows, (element) => {
            element.addEventListener('click', this.handleArrowAction.bind(this))
        })

        Array.prototype.forEach.call(this.thumbnails, (element) => {
            element.addEventListener('click', this.handleImageClick.bind(this))
        })

        if (!isNull(this.close)) {
            window.addEventListener('keydown', this.handleKeyDown.bind(this))
            this.close.addEventListener('click', this.hideGallery.bind(this))
        }
    }

    handleKeyDown(event) {
        if (!this.container.classList.contains('is-enabled')) {
            return
        }

        switch (event.keyCode) {
            case 27:
                this.hideGallery()
                break
            case 37:
                this.transitionSlideLeft()
                break
            case 39:
                this.transitionSlideRight()
                break
        }
    }

    handleImageClick(event) {
        this.showGallery()
        this.setActiveImage(event.target)
    }

    handleArrowAction(event) {
        event.stopPropagation()
        this.handleTransitionSlide(event.target.getAttribute('data-direction'))
    }

    handleTransitionSlide(direction) {
        switch (direction) {
            case 'left':
                this.transitionSlideLeft()
                break
            default:
                this.transitionSlideRight()
                break
        }
    }

    showGallery() {
        this.thumbnails = document.querySelectorAll('.product-gallery-thumbnails img')
        this.imageArray = Array.from(this.thumbnails)
        this.lastImage = this.imageArray.length - 1

        this.container.classList.add('is-enabled')
        this.bodyEl.classList.add('overflow-hidden')
    }

    hideGallery() {
        this.container.classList.remove('is-enabled')
        this.bodyEl.classList.remove('overflow-hidden')
    }

    setActiveImage(image) {
        this.previewImage.src = image.dataset.imagesrc
        this.activeImage = parseInt(image.getAttribute('data-index'))
    }

    transitionSlideLeft() {
        if (this.activeImage === 0) {
            this.setActiveImage(this.imageArray[this.lastImage])
        } else {
            this.setActiveImage(this.imageArray[this.activeImage - 1])
        }
    }

    transitionSlideRight() {
        if (this.activeImage === this.lastImage) {
            this.setActiveImage(this.imageArray[0])
        } else {
            this.setActiveImage(this.imageArray[this.activeImage + 1])
        }
    }
}
